import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DespesaNivelComponent } from './despesa-nivel.component';

const routes: Routes = [
  {
    path: ':ano/:sistema',
    component: DespesaNivelComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DespesaNivelRoutingModule { }

